import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import WhiteBoard from './components/whiteBoard';
import Tools from './components/tools';
import History from './components/history';
import "./App.css"
import AngleRange from './ANGLE';
import Store from './store';

import EventBus from "./eventBus"
import ToolStore, { POINTER, PEN, LINE, ELLIPSE, RECT, ARROW, NOTHING } from './toolStore';

import Draggable from 'react-draggable';



const EditorIndex = (props) => {

  const [Angle, setAngle] = useState(90)
  const [AngleRight, setAngleRight] = useState(0)
  const [AngleLeft, setAngleLeft] = useState(0)
  // console.log(Angle,"Angle")
  useEffect(() => {
    if (!props.ShowAngle) {
      props.setAngle && props.setAngle(0)
    } else {
      props.setAngle && props.setAngle(Angle)
    }
  }, [Angle,props.ShowAngle])
  useEffect(() => {
    // EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

  }, [Angle])

  useEffect(() => {
    setAngle(90)
  }, [props.ShowAngle])
  return (
    <div id='main'>
      <div id='container' style={{ position: "relative",display:"flex",height:"100%" }}>
        <Tools />
        <WhiteBoard />
        {
          props.Text?.map((value, index) => {
            return (
              <Draggable
                key={index}
                onStart={() => {
                  EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)
                  props.newSelection()
                }}
                bounds="div">
                <h2

                  style={{
                    width: "auto",
                    position: "absolute",
                    fontWeight: "bold",
                    fontSize: "30px",
                    color: value.color,
                    cursor: "grab",
                    zIndex:10000000000000,
                    userSelect:"none"
                    // /* margin: 10px; */
                    // /* padding: 30px; */
                    // background: "white",
                  }}
                >
                  {value.text}
                </h2>
              </Draggable>
            )
          })
        }

        <Draggable
          onStart={() => {
            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)
            props.SelectedNuller()

          }}
           handle="strong"  >


          <div style={{ position: "absolute", }} >
            {/* <strong className="cursor"><div>Drag here</div></strong> */}

            <strong style={{
              "border": "6px solid transparent",
              top: "46%",
              left: "47%",
              "zIndex": "10",
              "position": "absolute",
              cursor: "pointer",
            }} />



            {
              props.ShowAngle ? (
                <>
                  <AngleRange
                    value={{ from: 0, to: 90 }}
                    onChange={(e) => {
                      // setAngle(e.to)
                      // if(e.from == 0 && e.to == 0){
                      //   return
                      // }
                      let num = 360 - e.from + e.to;

                      if (num > 360) {
                        num = num - 360
                      }

                      setAngle(num)

                    }}
                    isDisabled={false}
                    limitFrom={{ min: 0, max: 360 }}
                    limitTo={{ min: 0, max: 360 }}
                    radius={120}
                    handlerRangeRadiusOffset={30}
                    handlerRadius={10}
                    offsetHandlerRadius={10}
                    offsetHandlerRadiusOffset={10}
                    // min={0}
                    // max={90}
                    isQuarterCircle={false}

                  />
                  <span
                    style={{
                      "position": "absolute",
                      "top": "42%",
                      "right": "45px",
                      borderRadius: "50%",
                      padding: "5px",
                      fontSize: "13px",
                      background: "#03e133",
                      color: "black",
                    }}
                  > {Angle}˚ </span>

                  {/* <span
                    id="MyNewCross"
                    onClick={() => props.HideAngle()}
                    style={{
                      "position": "absolute",
                      "top": "4%",
                      "right": "101px",
                      "borderRadius": "50%",
                      "padding": "3px 7px",
                      "fontSize": "9px",
                      "background": "black",
                      "color": "chartreuse",
                      cursor: "pointer"
                    }}
                  > X </span> */}
                </>
              ) : null
            }
          </div>


        </Draggable>

      </div>
      {/* <History /> */}
    </div>
  )
}
export default EditorIndex